import {
  object,
  string,
  array,
  number,
  boolean,
  mixed,
  SchemaOf,
  StringSchema,
} from 'yup';

import { AllowedSourceScope, KubernetesRegistryFormValues } from './types';

export function createKubernetesRegistryValidationSchema(
  nameValidation: StringSchema<string>
): SchemaOf<KubernetesRegistryFormValues> {
  return object({
    name: nameValidation,
    environmentGroupIds: array(number().required()),
    restrictSources: boolean().required(),
    allowedSources: array(
      object({
        registryUrlPrefix: string().required('Registry URL prefix is required'),
        scope: mixed<AllowedSourceScope>()
          .oneOf(['global', 'namespaces'] as const)
          .required(),
        namespaces: array(string().required()).when('scope', {
          is: 'namespaces',
          then: (schema) => schema.min(1, 'At least one namespace is required'),
          otherwise: (schema) => schema,
        }),
      })
    ).when('restrictSources', {
      is: true,
      then: (schema) =>
        schema.min(1, 'At least one allowed source is required'),
      otherwise: () => array().notRequired(),
    }),
    accessRows: array(
      object({
        id: number().min(1).required(),
        registryId: number().min(1).required(),
        registryName: string().optional(),
        namespaces: array(string().required()).min(
          1,
          'At least one namespace is required'
        ),
      })
    ).test(
      'access-or-restrict',
      'Add at least one registry access or enable restrict sources',
      (value, context) => {
        const { restrictSources } = context.parent;
        if (restrictSources) {
          return true;
        }
        return Array.isArray(value) && value.length > 0;
      }
    ),
  });
}
